/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
import { isPlatformBrowser } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { type AccountDetail } from '../../shared/models/account-detail';
import { catchError, concatMap, EMPTY, map, of } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, Validators } from '@angular/forms';
import { emailValidator } from '../../shared/validators/email.validator';
import { EmailInfo } from '../../shared/models/email-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Person } from '../../shared/models/person';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';

@Component({
  selector: 'app-refer-friend',
  imports: [
    MatDividerModule,
    MatButtonModule,
    EmailFormComponent,
    MatFormFieldModule,
    MatInputModule,
    MatTooltip,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
  templateUrl: './refer-friend.component.html',
  styleUrl: './refer-friend.component.scss',
})
export class ReferFriendComponent {
  pageLabels: any = {};
  pageReady = false;
  formErrorMessage?: string = '';
  emailFormData: any = {};
  accountDetail: AccountDetail;
  hasEmail: boolean = false;
  isBrowser = false;
  referAFriendCode: string = '';
  headerData = new PageHeader();
  pageName = 'Refer A Friend';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly formBuilder: FormBuilder,
    private readonly account: AccountService,
    private readonly router: Router,
    private readonly error: ErrorService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-refer-a-friend', 'OAS Refer a Friend')
      .pipe(
        map((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.referFriendHeader;
          this.seoS.setSeoTags(data.seo);
        }),
      )
      .subscribe(() => {
        if (this.isBrowser) {
          this.hasEmail =
            this.accountDetail.Person?.EmailAddresses?.find((email: EmailInfo) => {
              return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
            })?.IsPrimary ?? false;
          if (!this.hasEmail) {
            this.setupEmailData();
          }
          this.referAFriendCode = this.accountDetail.ReferFriendCode;
          this.pageReady = true;
          this.utils.hideSpinner();
        }
      });
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  getReferralCode(): void {
    this.formErrorMessage = '';
    const accountNumber = this.accountDetail?.AccountNumber;
    if (!this.hasEmail) {
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;
        this.utils.showSpinner();
        this.account
          .getReferFriendLink(accountNumber, emailValue)
          .pipe(
            catchError((e) => {
              this.error.setErrorData('none', this.pageLabels.referFriendErrorData);
              void this.router.navigateByUrl(Nav.ErrorPage);
              return EMPTY;
            }),
            concatMap((data: any) => {
              this.referAFriendCode = data;
              return of('success');
            }),
          )
          .subscribe((data: any) => {
            if (data === 'success') {
              this.accountDetail.ReferFriendCode = this.referAFriendCode;
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
              this.utils.hideSpinner();
            }
            this.utils.showSpinner();
            const emailValue = this.emailFormData.formGroup.value.email;
            const emailList = this.accountDetail.Person?.EmailAddresses;
            if (emailList && emailList.length > 0) {
              emailList.forEach((email) => {
                email.IsPrimary = false;
              });
            }

            const personRequest = this.accountDetail?.Person;
            const email = new EmailInfo();
            email.ContactId = '';
            email.Email = emailValue;
            email.IsActive = true;
            email.IsPrimary = true;
            email.Type = 'EMAIL';
            personRequest?.EmailAddresses?.push(email);

            this.account.UpdatePersonContact(personRequest).subscribe((data: Person) => {
              this.accountDetail.Person = data;
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
              this.utils.hideSpinner();
              return EMPTY;
            });
          });
      } else {
        const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
        this.emailFormData.formGroup.markAllAsTouched();
        this.showFormErrorLabel(errorMessage);
        this.utils.hideSpinner();
      }
    } else {
      this.utils.showSpinner();
      const emailValue =
        this.accountDetail.Person?.EmailAddresses?.find((email: EmailInfo) => {
          return email.IsPrimary;
        })?.Email ?? '';
      this.account.getReferFriendLink(accountNumber, emailValue).subscribe({
        error: (e) => {
          this.error.setErrorData('none', this.pageLabels.referFriendErrorData);
          void this.router.navigateByUrl(Nav.ErrorPage);
        },
        next: (data: any) => {
          this.utils.hideSpinner();
          this.referAFriendCode = data;
          this.accountDetail.ReferFriendCode = this.referAFriendCode;
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        },
      });
    }
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  copyText(inputValue: any): void {
    navigator.clipboard.writeText(inputValue).catch(() => {
      console.error('Unable to copy text');
    });
  }

  openFB(): void {
    const fbUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(this.accountDetail.ReferFriendCode);
    window.open(fbUrl, 'mypopuptitle', 'width=600,height=400');
  }
}
